import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { AUTOMATIC_COUPON_SETTINGS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getAutomaticCouponSettingsAction = createAsyncThunk(
    'coupon/getAutomaticCouponSettingsAction',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(AUTOMATIC_COUPON_SETTINGS_PATH);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getAutomaticCouponSettingsSlice = createSlice({
    name: 'getAutomaticCouponSettingsSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getAutomaticCouponSettingsAction.pending, () => STATE__API__STARTED);
        builder.addCase(getAutomaticCouponSettingsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getAutomaticCouponSettingsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getAutomaticCouponSettingsState = (state) => state.coupon.getAutomaticCouponSettings;
export default getAutomaticCouponSettingsSlice.reducer;
